import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const NotificationSnackbarV1 = ({ 
  open, 
  message, 
  severity = 'info', 
  onClose, 
  autoHideDuration = 6000,
  anchorOrigin = { vertical: 'top', horizontal: 'right' }
}) => {
    console.log("Snackbar rendered", open, message); // ✅ Log here
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert 
        onClose={onClose} 
        severity={severity} 
        sx={{ 
          width: '100%',
          minWidth: '300px',
          fontSize: '0.95rem',
          '& .MuiAlert-icon': {
            fontSize: '1.2rem'
          },
          zIndex: 9999 // ensures it's above other content
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbarV1;
